import { AzureADAppPermissionGrantModel } from '../../../microsoft/azuread/profile/azure-adapp-permission-grant-model';

export class AzureADAppPermissionsModel {
  azureADAppPermissionGrants: AzureADAppPermissionGrantModel[];
}
